<template>
  <div
    v-if="scoreBreakdown"
    class="rounded-xl p-5 border border-gray-700 overflow-hidden"
    data-e2e="profile-matching-card"
  >
    <!-- Header (always visible, clickable to toggle) -->
    <div
      class="flex items-center gap-3 cursor-pointer select-none"
      @click="expanded = !expanded"
    >
      <span class="uppercase text-gray-300 text-lg whitespace-nowrap">{{ t('matching_evaluation.title') }}</span>
      <div class="flex items-center gap-2">
        <div class="h-1.5 w-20 bg-gray-700 rounded-full overflow-hidden">
          <div
            class="h-full bg-primary rounded-full transition-all"
            :style="{ width: `${matchScore}%` }"
          />
        </div>
        <span class="text-primary text-sm font-medium min-w-[40px] text-right">
          {{ matchScore }}%
        </span>
      </div>
      <Icon
        :name="expanded ? 'solar:alt-arrow-up-linear' : 'solar:alt-arrow-down-linear'"
        class="size-5 text-gray-400 shrink-0 ml-auto"
      />
    </div>

    <!-- Expandable criteria list -->
    <ul v-if="expanded" class="space-y-2 mt-4">
      <li v-for="(item, idx) in explanationItems" :key="idx" class="flex items-start gap-2">
        <Icon :name="item.icon" class="size-4 shrink-0 mt-0.5" :class="item.iconClass" />
        <span class="text-sm text-white/90 leading-relaxed">{{ item.description }}</span>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { ref, toRef } from 'vue';
import type { ScoreBreakdown } from '~/api/v2/experts/ExpertRepository';
import { useScoreExplanation } from '~/composables/useScoreExplanation';

const { t } = useI18n();

const props = defineProps<{
  matchScore: number;
  scoreBreakdown: ScoreBreakdown;
}>();

const expanded = ref(false);

const { explanationItems } = useScoreExplanation(
  toRef(props, 'scoreBreakdown'),
  toRef(props, 'matchScore'),
);
</script>
